import styled from 'styled-components'

export const DefaultCard = () => (
  <CustomSvg
    fill="none"
    height="27"
    viewBox="0 0 40 27"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Payment">
      <rect x="0.5" y="0.5" width="40" height="27" rx="2" fill="#E7E7E7" />
      <rect id="Rectangle 8650" x="6.5" y="7.5" width="6" height="5" rx="1" fill="white" />
      <path
        clip-rule="evenodd"
        d="M10.5 18.5H6.5V20.5H10.5V18.5ZM18.5 18.5H14.5V20.5H18.5V18.5ZM22.5 18.5H26.5V20.5H22.5V18.5ZM34.5 18.5H30.5V20.5H34.5V18.5Z"
        fill-opacity="0.7"
        fill-rule="evenodd"
        fill="#999999"
        id="Union"
      />
    </g>
  </CustomSvg>
)

const CustomSvg = styled.svg`
  height: 27px;
  width: auto;
`
